import * as React from "react";
import {IUserContext} from "./types";

export const UserContext = React.createContext<IUserContext>(undefined);